import { render } from "./ThetalakeEnable.vue?vue&type=template&id=6bd2486c"
import script from "./ThetalakeEnable.vue?vue&type=script&lang=js"
export * from "./ThetalakeEnable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__